<template>
  <header class="site-header">
    <div class="container header-inner">
      <button class="brand" type="button" @click="$emit('change-tab', 'home')">
         <img class="brand-mark" src="@/assets/logo.png"  />
        <span class="brand-text">
          <strong>中鸿云智</strong>
          <small>ZHONGHONG DIGITAL</small>
        </span>
      </button>

      <nav class="desktop-tabs">
        <button
          v-for="item in tabs"
          :key="item.key"
          type="button"
          :class="['tab-btn', { active: activeTab === item.key }]"
          @click="$emit('change-tab', item.key)"
        >
          {{ item.label }}
        </button>
      </nav>

      <button class="cta" type="button" @click="$emit('change-tab', 'contact')">
        立即咨询
      </button>

      <button class="mobile-toggle" type="button" :class="{ open: expanded }" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <div class="mobile-panel" :class="{ show: expanded }">
      <div class="mobile-panel-inner">
        <button
          v-for="item in tabs"
          :key="item.key"
          type="button"
          :class="['mobile-tab-btn', { active: activeTab === item.key }]"
          @click="handleMobileClick(item.key)"
        >
          {{ item.label }}
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    activeTab: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  watch: {
    activeTab() {
      this.closeMenu()
    },
    expanded(value) {
      this.$emit('mobile-menu-toggle', value)
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    toggleMenu() {
      this.expanded = !this.expanded
    },
    closeMenu() {
      this.expanded = false
    },
    handleMobileClick(tabKey) {
      this.closeMenu()
      this.$emit('change-tab', tabKey)
    },
    handleDocumentClick(event) {
      if (!this.expanded) return
      if (!this.$el.contains(event.target)) {
        this.closeMenu()
      }
    },
    handleResize() {
      if (window.innerWidth > 768 && this.expanded) {
        this.closeMenu()
      }
    }
  }
}
</script>

<style scoped lang="less">
@primary: #2463eb;
@primary-dark: #1c4fbc;

.site-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 50;
  border-bottom: 1px solid #e7eefc;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.86);
}

.container {
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
}

.header-inner {
  min-height: 88px;
  display: flex;
  align-items: center;
  gap: 18px;
}

.brand {
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  cursor: pointer;
  text-align: left;
}

.brand-mark {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  //background: linear-gradient(135deg, @primary, #5ca0ff);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.brand-text strong {
  font-size: 18px;
  color: #152341;
}

.brand-text small {
  font-size: 10px;
  letter-spacing: 0.7px;
  color: #7d8eab;
}

.desktop-tabs {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.tab-btn {
  height: 40px;
  border: 0;
  background: transparent;
  border-radius: 20px;
  color: #445976;
  font-size: 14px;
  padding: 0 16px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.tab-btn:hover {
  color: @primary;
  background: #eff5ff;
}

.tab-btn.active {
  color: #fff;
  background: linear-gradient(135deg, @primary, @primary-dark);
  box-shadow: 0 8px 18px rgba(36, 99, 235, 0.24);
}

.cta {
  height: 42px;
  margin-left: 4px;
  border: 0;
  background: linear-gradient(135deg, @primary, @primary-dark);
  color: #fff;
  border-radius: 21px;
  padding: 0 20px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 10px 22px rgba(36, 99, 235, 0.3);
}

.cta:hover {
  transform: translateY(-1px);
}

.mobile-toggle {
  display: none;
  margin-left: auto;
  width: 40px;
  height: 40px;
  border: 1px solid #dbe6fb;
  border-radius: 10px;
  background: #fff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
}

.mobile-toggle span {
  width: 16px;
  height: 2px;
  background: #445976;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.mobile-panel {
  display: none;
}

@media (max-width: 1024px) {
  .container {
    width: min(1240px, calc(100% - 36px));
  }

  .desktop-tabs {
    gap: 4px;
  }

  .tab-btn {
    padding: 0 12px;
  }
}

@media (max-width: 768px) {
  .container {
    width: min(1240px, calc(100% - 24px));
  }

  .header-inner {
    min-height: 72px;
  }

  .brand-text strong {
    font-size: 16px;
  }

  .brand-text small,
  .desktop-tabs,
  .cta {
    display: none;
  }

  .mobile-toggle {
    display: inline-flex;
  }

  .mobile-panel {
    display: block;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
    transition: max-height 0.26s ease, opacity 0.2s ease;
    border-top: 1px solid #edf3ff;
    background: #fff;
  }

  .mobile-panel.show {
    max-height: 320px;
    opacity: 1;
    pointer-events: auto;
  }

  .mobile-toggle.open span:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
  }

  .mobile-toggle.open span:nth-child(2) {
    opacity: 0;
  }

  .mobile-toggle.open span:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
  }

  .mobile-panel-inner {
    padding-bottom: 8px;
  }

  .mobile-tab-btn {
    border: 0;
    border-bottom: 1px solid #edf3ff;
    background: #fff;
    text-align: left;
    padding: 14px 24px;
    color: #3f4f67;
    font-size: 15px;
    cursor: pointer;
  }

  .mobile-tab-btn.active {
    color: @primary;
    font-weight: 700;
  }
}
</style>
